export default __webpack_public_path__ + "static/agnes@2x-bc5d124cf855e57919f6b1eed5ef6a3a.png";